( function( global, $ ) {
    "use strict";

    var _events = {
        onSubmit: function(ev) {
            var $form = $(this);

            if ($form.data('form-state') === 'confirmed') {
                $form.data('form-state', null);

                return;
            }

            ev.preventDefault();

            $form.data('form-state', 'need-confirm');

            setTimeout(function() {
                if (confirm($form.data('form-confirm'))) {
                    $form.data('form-state', 'confirmed');

                    $form.trigger('submit');
                } else {
                    $form.data('form-state', null);
                }
            }, 100);
        }
    };

    var $body = $('body');

    $body.on('app.init', function(ev) {
        var $container = $(ev.container),
            $form = $container.find('form[data-form-confirm]');

        $form.on('submit', _events.onSubmit);
    });

}( window.groots, jQuery ));
